// MiniStat.jsx
const MiniStat = ({ label, value }) => {
  return (
    <div
      className="
        relative
        rounded-2xl p-4
        bg-blue-600 
        border border-white/10
        backdrop-blur-xl
        shadow-lg
        transition-all duration-300
        hover:scale-105 
        group flex flex-col items-center justify-center
      "
    >
      {/* Subtle inner glow */}
      <div className="absolute inset-0  rounded-2xl bg-white/5 opacity-0 group-hover:opacity-100 transition-all duration-500"></div>

      <p className="text-xs uppercase font-semibold tracking-widest text-white/70">
        {label}
      </p>

      <h4 className="text-2xl font-bold text-white mt-1 tracking-tight">
        {value}
      </h4>
    </div>
  );
};

export default MiniStat;